// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vrcR","col":"styles_col__3CCms"};